<template>
  <svg
    class="spin-animation"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12.96 8C12.96 9.0079 12.6529 9.9919 12.0797 10.8209C11.5064 11.6499 10.6942 12.2847 9.75124 12.6406C8.80819 12.9965 7.78909 13.0566 6.80105 12.8129C5.81301 12.5692 4.94241 12.0334 4.27652 11.2768C3.61062 10.5202 3.19109 9.57855 3.07374 8.57753C2.95638 7.57651 3.14548 6.56335 3.61963 5.6732C4.09377 4.78305 4.82527 4.0581 5.72045 3.59486C6.61563 3.13162 7.63068 2.95212 8.6304 3.08023"
        stroke="currentColor"
        stroke-width="1.2"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.spin-animation {
  animation: app-spin var(--app-spin-duration) linear infinite;
}
</style>
